<!-- TopNav Copyright 2022 Rebecca L Beaudet -->
<script>
  import { navPages, otherNavLinks } from '../language/pageContent';
  import { CORP_NAME } from '../language/constantContent';
  import Facebook from 'svelte-bootstrap-icons/lib/Facebook';
  import Instagram from 'svelte-bootstrap-icons/lib/Instagram';
  import Youtube from 'svelte-bootstrap-icons/lib/Youtube';
  import { Link } from 'svelte-routing';
  import { onMount } from 'svelte';

  let navbarEl = null;

  onMount(() => {
    navbarEl = document.getElementById('navbarCollapse');
  });

  const onMobileLinkClick = (e) => {
    setTimeout(() => {
      if (navbarEl) navbarEl.classList.toggle('show');
    }, 20);
  };
</script>

<header>
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <div class="container-fluid">
      <Link
        class="navbar-brand d-block d-md-none"
        to="/"
        on:click={onMobileLinkClick}
      >
        {CORP_NAME}
      </Link>
      <Link class="navbar-brand d-none d-md-block" to="/">
        {CORP_NAME}
      </Link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav me-auto mb-2 mb-md-0">
          {#each navPages as { path, navName }}
            <li class="nav-item">
              <Link
                class="nav-link d-block d-md-none"
                to={path}
                on:click={onMobileLinkClick}
              >
                {navName}
              </Link>
              <Link class="nav-link d-none d-md-block" to={path}>
                {navName}
              </Link>
            </li>
          {/each}
          {#each otherNavLinks as { path, name }}
            <li class="nav-item">
              <Link
                class="nav-link d-block d-md-none"
                to={path}
                on:click={onMobileLinkClick}
              >
                {name}
              </Link>
              <Link class="nav-link d-none d-md-block" to={path}>
                {name}
              </Link>
            </li>
          {/each}
          <li class="nav-item">
            <a
              class="nav-link"
              href="https://www.instagram.com/the_com_collab/"
            >
              <Instagram />
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="https://www.facebook.com/profile.php?id=61563388118016"
            >
              <Facebook />
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="https://www.youtube.com/channel/UCTrmz8CdPlCzTnLHfgvymjw"
            >
              <Youtube />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
